import styles from './Footer.module.css'

export default function Footer(){
    return (
    <footer className={styles.footer}>

        &copy; Direitos reservados aos devidos autores
    </footer>);
}